(function (Drupal, drupalSettings) {
  Drupal.behaviors.estimation = {
    attach: function (context, settings) {
      const form = context.querySelector("#estimationfraisform");
      if (form && !form.dataset.estimationProcessed) {
        form.dataset.estimationProcessed = "true";

        const hospitalisationInputs = form.querySelectorAll(
          "#edit-type-hospitalisation input"
        );
        hospitalisationInputs.forEach((input) => {
          input.addEventListener("change", function () {
            setTimeout(() => {
              const selectSpecialite = form.querySelector("#select-specialite");
              if (selectSpecialite) {
                selectSpecialite.dispatchEvent(new Event("change"));
                selectSpecialite.addEventListener("change", function () {
                  setTimeout(() => {
                    const selectIntervention = form.querySelector(
                      "#select-intervention"
                    );
                    if (selectIntervention) {
                      selectIntervention.dispatchEvent(new Event("change"));
                    }
                  }, 300);
                });
              }
            }, 300);
          });
        });
      }
    },
  };
})(Drupal, drupalSettings);
